import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// Étendre l'interface Navigator pour inclure wakeLock
interface Navigator {
  wakeLock?: {
    request: (type: 'screen') => Promise<any>;
  };
}

let wakeLock: any;

const requestWakeLock = async () => {
  try {
    if ((navigator as Navigator) .wakeLock) {
      wakeLock = await (navigator as Navigator).wakeLock?.request('screen');
    }
  } catch (err) {
    console.error(`${err}, ${err}`);
  }
};

requestWakeLock();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
